import * as types from "../types";

const initialState = {
    loading: false,
    loginReq: null,
    loginResult: null,
    error: null
}

export default function nbfcLoginReducer(state = initialState, action){
    
    switch(action.type){

        case types.NBFC_LOGIN_REQUEST :
            return{
                ...state,
                loading: true,
                loginReq: action.payload.loginReq,
            }

        case types.NBFC_LOGIN_SUCCESS :
            return{
                ...state,
                loading: false,
                loginResult: action.payload.loginResult,
            }

        case types.NBFC_LOGIN_FAILURE :
            return{
                ...state,
                loading: false,
                loginReq: null,
                loginResult: null,
                error: action.payload.error
            }


        case types.NBFC_LOGOUT_REQUEST :
            return{
                ...state,
                loading: true,
            }


        case types.NBFC_LOGOUT_SUCCESS :
            return{
                ...state,
                loading: false,
                loginReq: null,
                loginResult: null,
                error: null
            }

        default :
        return state;

    }

}